/**
 * Agent Name Mapping
 * Maps prompt_log agent names to SYSTEM_PROMPTS agent names
 * Used for cross-referencing between prompt logs and prompt editor
 */

// Mapping from prompt_log agent_name → system_prompts agent_name
export const AGENT_NAME_MAP = {
  // Persona/Chat agents
  "persona_voice_agent": "persona_chat",
  "PersonaVoice": "persona_chat",
  "PersonaVoiceAgent": "persona_chat",
  
  // Coaching agents
  "coach_overlay_agent": "coach_overlay_agent",
  "CoachOverlay": "coach_overlay_agent",
  "coaching_init": "coaching_init",
  "coaching_chat": "coaching_chat",
  "objective_coach": "objective_coach",
  "practice_coach": "practice_coach",
  
  // Mode routing
  "mode_router_agent": "mode_router_agent",
  "ModeRouter": "mode_router_agent",
  
  // Message crafting
  "MessageCraftingAgent": "comment_suggestions",
  "MessageCrafting": "comment_suggestions",
  "message_crafting": "comment_suggestions",
  
  // Analysis agents
  "analyze_image": "analyze_image",
  "compatibility_analysis": "compatibility_analysis",
  "emotion_detector": "emotion_detector",
  
  // Generation agents
  "core_dataset_gen": "core_dataset_gen",
  "core_profile_gen": "core_profile_gen",
  "ref_sheet_gen": "ref_sheet_gen",
  "style_card_gen": "style_card_gen",
  "auto_data_entry": "auto_data_entry",
  
  // Evaluation agents
  "ToneConsistencyEvaluator": "ToneConsistencyEvaluator",
  "HelpfulnessEvaluator": "HelpfulnessEvaluator",
  "PersonalizationEvaluator": "PersonalizationEvaluator",
  "ResponsePatternEvaluator": "ResponsePatternEvaluator",
  
  // Strategy/Planning
  "StrategyGenerator": "coach_overlay_agent",
  "stage_agent": "stage_agent",
  "plan_extractor_agent": "plan_extractor_agent",
  "signal_extractor_agent": "signal_extractor_agent",
  
  // Safety agents
  "ethics_guard": "ethics_guard",
  "risk_flagger": "risk_flagger",
  
  // Profile agents
  "user_profile_agent": "user_profile_agent",
  "persona_profile_agent": "persona_profile_agent",
  
  // Direct advice
  "advice_chat": "advice_chat",
  "advice_direct": "advice_chat",
};

/**
 * Get the system prompt agent name for a given log agent name
 * Falls back to the original name if no mapping exists
 */
export const getSystemPromptAgent = (logAgentName) => {
  if (!logAgentName) return null;
  return AGENT_NAME_MAP[logAgentName] || logAgentName;
};

/**
 * Check if a log agent has a known system prompt mapping
 */
export const hasSystemPromptMapping = (logAgentName) => {
  if (!logAgentName) return false;
  return logAgentName in AGENT_NAME_MAP || isKnownSystemPromptAgent(logAgentName);
};

/**
 * Known system prompt agent names (for direct matches)
 */
const KNOWN_SYSTEM_PROMPT_AGENTS = [
  "advice_chat",
  "persona_chat",
  "coaching_init",
  "coaching_chat",
  "coach_overlay_agent",
  "objective_coach",
  "practice_coach",
  "mode_router_agent",
  "comment_suggestions",
  "analyze_image",
  "compatibility_analysis",
  "conversation_starters",
  "quick_suggestions",
  "core_dataset_gen",
  "core_profile_gen",
  "ref_sheet_gen",
  "style_card_gen",
  "auto_data_entry",
  "emotion_detector",
  "stage_agent",
  "plan_extractor_agent",
  "ethics_guard",
  "risk_flagger",
  "user_profile_agent",
  "persona_profile_agent",
  "signal_extractor_agent",
  "ToneConsistencyEvaluator",
  "HelpfulnessEvaluator",
  "PersonalizationEvaluator",
  "ResponsePatternEvaluator",
];

export const isKnownSystemPromptAgent = (agentName) => {
  return KNOWN_SYSTEM_PROMPT_AGENTS.includes(agentName);
};
